export const CALENDAR_DISPLAY = 'CALENDAR_DISPLAY';
export const SUMMER_PACK = 'SUMMER_PACK';
export const NNLIVE = 'NNLIVE';
export const CYBER_MONDAY = 'CYBER_MONDAY';

